import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCampaigns } from '../contexts/CampaignContext';
import CampaignList from '../components/Campaigns/CampaignList';
import CampaignModal from '../components/Campaigns/CampaignModal';
import CampaignStats from '../components/Campaigns/CampaignStats';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiPlus } from 'react-icons/fi';


const Campaigns = () => {
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const { campaigns } = useCampaigns();

  const filteredCampaigns = campaigns.filter(campaign => 
    filterStatus === 'all' || campaign.status === filterStatus
  );

  const handleEditCampaign = (campaign) => {
    setSelectedCampaign(campaign);
    setShowCampaignModal(true);
  };

  const handleCloseModal = () => {
    setShowCampaignModal(false);
    setSelectedCampaign(null);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Campaigns</h1>
          <p className="text-gray-600">
            Create and manage your email and calling campaigns
          </p>
        </div>

        <div className="flex gap-3">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiFilter} className="text-gray-400" />
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">All Campaigns</option>
              <option value="draft">Draft</option>
              <option value="active">Active</option>
              <option value="paused">Paused</option>
              <option value="completed">Completed</option>
            </select>
          </div>
          
          <button
            onClick={() => setShowCampaignModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <SafeIcon icon={FiPlus} className="text-sm" />
            Create Campaign
          </button>
        </div>
      </div>

      {/* Campaign Stats */}
      <CampaignStats />

      {/* Campaign List */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <CampaignList 
          campaigns={filteredCampaigns}
          onEditCampaign={handleEditCampaign}
        />
      </motion.div>

      {/* Campaign Modal */}
      {showCampaignModal && (
        <CampaignModal
          campaign={selectedCampaign}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Campaigns;